import OperatingHourCompany from '../../components/operating-hour-company/OperatingHourCompany';

export function TimePage() {
  return <OperatingHourCompany></OperatingHourCompany>;
}
